import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  If,
  FormRadio,
  FormCombobox,
  Headline,
  FormMask,
  trEnv,
  appActions,
  SummingUp,
  SpeicherButton,
  PrevNextButton,
  useNextPage,
  useUpdateAndValidateOnChange,
  useUpdateByNameAndValidateOnChange,
} from 'ion-lib';
import { Col, Row } from 'react-bootstrap';
import i18next from 'i18next';
import { getBannerFileName, setWarningBeratersuche } from '../../helper';
import SummingupWarenkorb from '../../components/SummingupWarenkorb';

const Vorversicherung = () => {
  const updateAndValidateOnChange = useUpdateAndValidateOnChange(0);
  const validateOnChangeByName = useUpdateByNameAndValidateOnChange();
  const updateAndValidateVSNROnChange = useUpdateAndValidateOnChange();
  const nextPage = useNextPage();
  const dispatch = useDispatch();
  const vorversicherungHausrat = useSelector((state) => state.daten.vorversicherung);
  const vorversicherungNatur = useSelector((state) => state.daten.vorversicherungNatur);
  const vorversicherungGlas = useSelector((state) => state.daten.vorversicherungGlas);
  const wagnis = useSelector((state) => state.daten.wagnis);

  const zuVieleVorschaeden = vorversicherungGlas.schaeden.warning
    || vorversicherungHausrat.schaeden.warning
    || vorversicherungNatur.schaeden.warning;

  const gekuendigt = vorversicherungHausrat.gekuendigt.warning || vorversicherungGlas.gekuendigt.warning;

  const handleNextClick = () => {
    dispatch(appActions.serverValidationRequest('validiere', [
      'vorversicherung.auswahl',
      'vorversicherung.name',
      'vorversicherung.gekuendigt',
      'vorversicherung.schaeden',
      'vorversicherung.vsnr',
      'vorversicherungNatur.schaeden',
      'vorversicherungNatur.schadensursache',
      'vorversicherungNatur.rueckstausicherung',
      'vorversicherungGlas.auswahl',
      'vorversicherungGlas.name',
      'vorversicherungGlas.gekuendigt',
      'vorversicherungGlas.schaeden',
      'vorversicherungGlas.vsnr',
    ], () => {
      nextPage();
    }));
  };

  return (
    <Row>
      <Col>
        <div className="w-md spkpanel">
          <Headline>Vorversicherung</Headline>

          <If predicate={vorversicherungHausrat.auswahl.relevant}>
            <FormRadio
              {...vorversicherungHausrat.auswahl}
              title="Haben oder hatten Sie bereits eine Hausratversicherung?"
              onChange={updateAndValidateOnChange}
              name="daten.vorversicherung.auswahl.value"
              className="mb-5"
            />
          </If>
          <If predicate={vorversicherungHausrat.name.relevant}>
            <FormCombobox
              {...vorversicherungHausrat.name}
              title="Bei welcher Versicherung?"
              onChange={validateOnChangeByName}
              name="daten.vorversicherung.name.value"
              className="mb-5"
              createable
            />
          </If>
          <If predicate={vorversicherungHausrat.vsnr.relevant}>
            <FormMask
              {...vorversicherungHausrat.vsnr}
              name="daten.vorversicherung.vsnr.value"
              title={i18next.t('vorversicherung.vsnr_label')}
              onChange={updateAndValidateVSNROnChange}
              className="mb-5"
              inputmask={{
                mask: '********************',
                formatChars: {
                  '*': '.{1,50}',
                },
                maskChar: '',
              }}
            />
          </If>
          <If predicate={vorversicherungHausrat.gekuendigt.relevant}>
            <FormRadio
              {...vorversicherungHausrat.gekuendigt}
              title="Durch wen wird oder wurde der Vertrag gekündigt?"
              onChange={updateAndValidateOnChange}
              name="daten.vorversicherung.gekuendigt.value"
              className="mb-5"
              message={vorversicherungHausrat.gekuendigt.warning && `<p>${setWarningBeratersuche(vorversicherungHausrat.gekuendigt.warning, wagnis)}</p>`}
            />
          </If>
          <If predicate={vorversicherungHausrat.schaeden.relevant && !trEnv.stationaer}>
            <FormRadio
              {...vorversicherungHausrat.schaeden}
              title="Wie viele Hausratschäden hatten Sie in den letzten 5 Jahren?"
              onChange={updateAndValidateOnChange}
              name="daten.vorversicherung.schaeden.value"
              className="mb-5"
              message={vorversicherungHausrat.schaeden.warning && `<p>${setWarningBeratersuche(vorversicherungHausrat.schaeden.warning, wagnis)}</p>`}
              tooltip={() => dispatch(appActions.toggleModal(i18next.t('vorversicherung.hausratschaeden_tt')))}
            />
          </If>
          <If predicate={vorversicherungHausrat.schaeden.relevant && trEnv.stationaer}>
            <FormCombobox
              {...vorversicherungHausrat.schaeden}
              title="Wie viele Hausratschäden hatten Sie in den letzten 5 Jahren?"
              onChange={validateOnChangeByName}
              name="daten.vorversicherung.schaeden.value"
              className="mb-5"
              message={vorversicherungHausrat.schaeden.warning && `<p>${setWarningBeratersuche(vorversicherungHausrat.schaeden.warning, wagnis)}</p>`}
              tooltip={() => dispatch(appActions.toggleModal(i18next.t('vorversicherung.hausratschaeden_tt')))}
            />
          </If>
          <If predicate={vorversicherungNatur.schaeden.relevant && !trEnv.stationaer}>
            <FormRadio
              {...vorversicherungNatur.schaeden}
              title="Wie viele Schäden aus Naturgefahren (Elementarschäden) hatten Sie in den letzten 10 Jahren?"
              onChange={updateAndValidateOnChange}
              name="daten.vorversicherungNatur.schaeden.value"
              className="mb-5"
              tooltip={() => dispatch(appActions.toggleModal(i18next.t('vorversicherung.naturschaeden_tt')))}
              message={vorversicherungNatur.schaeden.warning && `<p>${setWarningBeratersuche(vorversicherungNatur.schaeden.warning, wagnis)}</p>`}
            />
          </If>
          <If predicate={vorversicherungNatur.schaeden.relevant && trEnv.stationaer}>
            <FormCombobox
              {...vorversicherungNatur.schaeden}
              title="Wie viele Schäden aus Naturgefahren (Elementarschäden) hatten Sie in den letzten 10 Jahren?"
              onChange={validateOnChangeByName}
              name="daten.vorversicherungNatur.schaeden.value"
              className="mb-5"
              tooltip={() => dispatch(appActions.toggleModal(i18next.t('vorversicherung.naturschaeden_tt')))}
              message={vorversicherungNatur.schaeden.warning && `<p>${setWarningBeratersuche(vorversicherungNatur.schaeden.warning, wagnis)}</p>`}
            />
          </If>
          <If predicate={vorversicherungNatur.schadensursache.relevant}>
            <FormCombobox
              {...vorversicherungNatur.schadensursache}
              title="Was war die Schadensursache?"
              onChange={validateOnChangeByName}
              name="daten.vorversicherungNatur.schadensursache.value"
              className="mb-5 mt-n5 pt-3"
              labelClassName="fw-light"
            />
          </If>
          <If predicate={vorversicherungNatur.rueckstausicherung.relevant}>
            <FormCombobox
              {...vorversicherungNatur.rueckstausicherung}
              title="Welche Rückstausicherungen sind vorhanden?"
              onChange={validateOnChangeByName}
              name="daten.vorversicherungNatur.rueckstausicherung.value"
              tooltip={() => dispatch(appActions.toggleModal(i18next.t('vorversicherung.rueckstausicherung_tt')))}
              className="mb-5"
            />
          </If>

          <If predicate={vorversicherungGlas.auswahl.relevant}>
            <FormRadio
              {...vorversicherungGlas.auswahl}
              title="Haben oder hatten Sie bereits eine Glasversicherung?"
              onChange={updateAndValidateOnChange}
              name="daten.vorversicherungGlas.auswahl.value"
              className="mb-5"
            />
          </If>
          <If predicate={vorversicherungGlas.name.relevant}>
            <FormCombobox
              {...vorversicherungGlas.name}
              title="Bei welcher Versicherung?"
              onChange={validateOnChangeByName}
              name="daten.vorversicherungGlas.name.value"
              className="mb-5"
              createable
            />
          </If>
          <If predicate={vorversicherungGlas.vsnr.relevant}>
            <FormMask
              {...vorversicherungGlas.vsnr}
              name="daten.vorversicherungGlas.vsnr.value"
              title={i18next.t('vorversicherung.vsnr_label')}
              onChange={updateAndValidateVSNROnChange}
              className="mb-5"
              inputmask={{
                mask: '********************',
                formatChars: {
                  '*': '.{1,50}',
                },
                maskChar: '',
              }}
            />
          </If>
          <If predicate={vorversicherungGlas.gekuendigt.relevant}>
            <FormRadio
              {...vorversicherungGlas.gekuendigt}
              title="Durch wen wird oder wurde der Vertrag gekündigt?"
              onChange={updateAndValidateOnChange}
              name="daten.vorversicherungGlas.gekuendigt.value"
              className="mb-5"
              message={vorversicherungGlas.gekuendigt.warning && `<p>${setWarningBeratersuche(vorversicherungGlas.gekuendigt.warning, wagnis)}</p>`}
            />
          </If>
          <If predicate={vorversicherungGlas.schaeden.relevant && !trEnv.stationaer}>
            <FormRadio
              {...vorversicherungGlas.schaeden}
              title="Wie viele Glasbruchschäden hatten Sie in den letzten 5 Jahren?"
              onChange={updateAndValidateOnChange}
              name="daten.vorversicherungGlas.schaeden.value"
              className="mb-5"
              tooltip={() => dispatch(appActions.toggleModal(i18next.t('vorversicherung.glasschaeden_tt')))}
              message={vorversicherungGlas.schaeden.warning && `<p>${setWarningBeratersuche(vorversicherungGlas.schaeden.warning, wagnis)}</p>`}
            />
          </If>
          <If predicate={vorversicherungGlas.schaeden.relevant && trEnv.stationaer}>
            <FormCombobox
              {...vorversicherungGlas.schaeden}
              title="Wie viele Glasbruchschäden hatten Sie in den letzten 5 Jahren?"
              onChange={validateOnChangeByName}
              name="daten.vorversicherungGlas.schaeden.value"
              className="mb-5"
              tooltip={() => dispatch(appActions.toggleModal(i18next.t('vorversicherung.glasschaeden_tt')))}
              message={vorversicherungGlas.schaeden.warning && `<p>${setWarningBeratersuche(vorversicherungGlas.schaeden.warning, wagnis)}</p>`}
            />
          </If>
        </div>
        <Row>
          <Col>
            <PrevNextButton
              className="d-md-none oev-show spk-show"
              nextProps={{
                text: 'Weiter',
                disabled: (zuVieleVorschaeden || gekuendigt) && !trEnv.stationaer,
              }}
              onNextClick={handleNextClick}
            />
            <SpeicherButton />
          </Col>
        </Row>
      </Col>
      <SummingUp bannerImg={getBannerFileName}>
        <SummingupWarenkorb />
      </SummingUp>
    </Row>
  );
};

export default Vorversicherung;
